import { FC } from 'react';
import { Chip } from "@mui/material";
import { PostRequestStatus } from "@libs/types";

interface PostRequestStatusChipProps {
  status?: PostRequestStatus | string;
}

export const PostRequestStatusChip: FC<PostRequestStatusChipProps> = ({ status }) => {
  const formattedStatus = `${status?.charAt(0).toUpperCase()}${status?.substring(1)}`;
  let backgroundColor;
  let color;

  switch (status) {
    case PostRequestStatus.PENDING:
      backgroundColor = 'secondary.light';
      color = 'secondary.dark';
      break;
    case PostRequestStatus.PROCESSING:
      backgroundColor = 'warning.light';
      color = 'warning.contrastText';
      break;
    case PostRequestStatus.DONE:
      backgroundColor = 'success.light';
      color = 'success.contrastText';
      break;
    case PostRequestStatus.CANCELLED:
      backgroundColor = 'error.light';
      color = 'error.contrastText';
      break;
    default:
      backgroundColor = 'secondary.light';
      color = 'secondary.dark';
  }

  return <Chip label={formattedStatus} sx={{ backgroundColor, color }} size="small" />;
};

export default PostRequestStatusChip;
